import { Action } from '@ngrx/store';
import { ICustomer } from '@signal/asp-data-commons';

export enum SearchCustomersActionTypes {
    SEARCH_CUSTOMERS = '[Search Customers] Search Customers',
    SEARCH_CUSTOMERS_SUCCESS = '[Search Customers] Search Customers Success',
    SEARCH_CUSTOMERS_FAILURE = '[Search Customers] Search Customers Failure',
    LOAD_CUSTOMER = '[Search Customers] Load Customer',
    DIRECT_LOAD_CUSTOMER = '[Search Customers] Direct Load Customer',
    LOAD_CUSTOMER_SUCCESS = '[Search Customers] Load Customer Success',
    LOAD_CUSTOMER_FAILURE = '[Search Customers] Load Customer Failure',
    SET_PENDING_SEARCH_INPUT = '[Search Customers] Set Pending Search Input',
    CLEAR_PENDING_SEARCH_INPUT = '[Search Customers] Clear Pending Search Input',
    CLEAR_CUSTOMER_SELECTION = '[Schedule Dashboard] Clear Customer Selection'
}

export type SearchInputFilterType = 'phone' | 'email' | 'vin' | 'licensePlate';

export interface PendingSearchInput {
    firstName: string;
    lastName: string;
    filterType: SearchInputFilterType;
    query: string;
    stateCode?: string;
    createdAt: string;
}

export class SearchCustomers implements Action {
    readonly type: string = SearchCustomersActionTypes.SEARCH_CUSTOMERS;

    constructor(public payload: { firstName: string, lastName: string, query: string, customerId?:number }) {

    }
}

export class SearchCustomersSuccess implements Action {
    readonly type: string = SearchCustomersActionTypes.SEARCH_CUSTOMERS_SUCCESS;

    constructor(public payload: { customers: ICustomer[] }) {

    }
}

export class SearchCustomersFailure implements Action {
    readonly type: string = SearchCustomersActionTypes.SEARCH_CUSTOMERS_FAILURE;

    constructor(public payload: { error: string }) {

    }
}

export class LoadCustomer implements Action {
    readonly type: string = SearchCustomersActionTypes.LOAD_CUSTOMER;

    constructor(public payload: { customerId: string}){

    }
}
export class DirectLoadCustomer implements Action {
    readonly type: string = SearchCustomersActionTypes.DIRECT_LOAD_CUSTOMER;

    constructor(public payload: { customers: ICustomer[], customerId: number}){

    }
}

export class LoadCustomerSuccess implements Action {
    readonly type: string = SearchCustomersActionTypes.LOAD_CUSTOMER_SUCCESS;

    constructor(public payload: { customer: ICustomer}){

    }
}

export class ClearCustomerSelection implements Action {
    readonly type: string = SearchCustomersActionTypes.CLEAR_CUSTOMER_SELECTION;
}

export class LoadCustomerFailure implements Action {
    readonly type: string = SearchCustomersActionTypes.LOAD_CUSTOMER_FAILURE;

    constructor(public payload: { error: string }){
        
    }
}

export class SetPendingSearchInput implements Action {
    readonly type: string = SearchCustomersActionTypes.SET_PENDING_SEARCH_INPUT;

    constructor(public payload: { pendingSearchInput: PendingSearchInput }) {

    }
}

export class ClearPendingSearchInput implements Action {
    readonly type: string = SearchCustomersActionTypes.CLEAR_PENDING_SEARCH_INPUT;
}

export type SearchCustomersActions = 
    | SearchCustomers 
    | SearchCustomersSuccess 
    | SearchCustomersFailure
    | LoadCustomer
    | LoadCustomerSuccess
    | LoadCustomerFailure
    | SetPendingSearchInput
    | ClearPendingSearchInput
    | ClearCustomerSelection
    ;